define('editor/edit/layers/add/index',['durandal/system', 'durandal/app', 'jquery', 'plugins/http', 'plugins/dialog', 'knockout', 'knockout-mapping'], function (system, app, $, http, dialog, ko, komapping) {
    return {
        editorMapId: null,
        mapLayerTypes: ko.observableArray([]),
        composeModule: null,

        activate: function (editorMapId, composeModuleFunc, cancelFunc) {
            var self = this;
            
            self.editorMapId = editorMapId;
            self.composeModule = composeModuleFunc;
            self.cancel = cancelFunc;
            
            self.fetchLayerTypes()
                .then(function (response) {
                    if (response.data) {
                        self.mapLayerTypes.removeAll();
                        if (response.data.mapLayerTypes.length) {
                            var spliceArgs = [0, 0].concat(response.data.mapLayerTypes);
                            self.mapLayerTypes.splice.apply(self.mapLayerTypes, spliceArgs);
                        }
                    } else {
                        self.showLayerTypesFail();
                    }
                }).fail(function () {
                    self.showLayerTypesFail();
                });
        },

        fetchLayerTypes: function() {
            var url = "/api/editor/layers/types",
                data = {
                    editorMapId: this.editorMapId
                };

            return http.get(url, data);
        },

        showLayerTypesFail: function () {
            dialog.showMessage("Unable to retrieve map layer types", "Unexpected Error");
        },

        returnToLayerList: function () {
            this.cancel();
        },

        next: function (model, event) {
            var chosenLayerType = $(event.currentTarget)
                .closest('[data-view]')
                .find('[type=radio]:checked')
                .val();
            
            if (!chosenLayerType) {
                return;
            }

            switch (chosenLayerType.toLowerCase()) {
                case 'directions':
                    this.composeModule('editor/edit/layers/add/directions/index');
                    break;
                case 'boundary':
                    this.composeModule('editor/edit/layers/add/boundaries/index');
                    break;
                case 'geojson':
                    this.composeModule('editor/edit/layers/add/geojson/index');
                    break;
                case 'kml':
                    this.composeModule('editor/edit/layers/add/kml/index');
                    break;
                case 'legend':
                    this.composeModule('editor/edit/layers/add/legend/index');
                    break;
                case 'overlay':
                    this.composeModule('editor/edit/layers/add/overlay/index');
                    break;
                default:
                    this.createNewLayer(chosenLayerType);
                    break;
            }
        },

        createNewLayer: function (type, state) {
            var self = this,
                url = "/api/editor/layers/add",
                data = {
                    editorMapId: self.editorMapId,
                    type: type,
                    state: state
                };

            return http.post(url, data)
                .then(function (response) {
                    if (response.success) {
                        var layerData = response.data["createdLayer"],
                            layerState = komapping.fromJS(layerData.state),
                            layer = {
                                id: ko.observable(layerData.id),
                                name: ko.observable(layerData.name),
                                groupId: ko.observable(data.groupId),
                                groupName: ko.observable(data.groupName),
                                groupColour: ko.observable(data.groupColour),
                                visible: ko.observable(layerData.visible),
                                type: ko.observable(layerData.type),
                                order: ko.observable(layerData.order),
                                state: ko.observable(layerState)
                            };
                        
                        delete layerState['__ko_mapping__'];

                        app.trigger("layer:new", layer);
                        
                        self.returnToLayerList();
                    } else {
                        dialog.showMessage("Failed to add layer", "Add Layer");
                    }
                }).fail(function () {
                    dialog.showMessage("Failed to add layer", "Add Layer");
                });
        }
    };
});
